// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --header-height-mobile: 5.5rem;
    --mobile-width: 800px;
    --header-height-desktop: 6.5rem;

    --header-height-default: var(--header-height-desktop);

    /*========== Colors ==========*/
    /*Color mode HSL(hue, saturation, lightness)*/
    --black-color: hsl(220, 24%, 12%);
    --black-color-light: hsl(220, 24%, 15%);
    --black-color-lighten: hsl(220, 20%, 18%);
    --white-color: #fff;
    --body-color: hsl(220, 100%, 97%);
    --electric-blue-color: #009fe3;
    --electric-blue-color-light: #00acf6;
    --neon-green-color: #66e700;
    --electric-yellow: #eeff07;

    /*========== Font and typography ==========*/
    /*.5rem = 8px | 1rem = 16px ...*/
    --body-font: "Montserrat", sans-serif;
    --normal-font-size: .938rem;
    --content-padding-small: 0 2rem;
    --content-padding-big: 0 min(10%, 10rem);

    /*========== Font weight ==========*/
    --font-regular: 400;
    --font-semi-bold: 600;

    /*========== z index ==========*/
    --z-tooltip: 10;
    --z-fixed: 100;

}

@media screen and (min-width: 950px) {
    :root {
        --normal-font-size: 1rem;
    }
}

@media screen and (max-width: 800px) {
    :root {
        --header-height-default: var(--header-height-mobile);
    }

}

/*========== Base ==========*/
* {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}

html,
body {
    height: 100vh;
    font-family: var(--body-font);
    font-size: var(--normal-font-size);
    background-color: var(--body-color);
    /* scroll-behavior: smooth; */
}

ol {
    counter-reset: item;
}

ol>li {
    list-style-type: none;
    position: relative;
}

ol>li {
    display: block;
}

ol>li:before {
    position: absolute;
    content: counter(item) ".";
    font-weight: var(--font-semi-bold);
    counter-increment: item;
    color: var(--black-color);
    display: inline-block;
    left: -18px
}

ul {
    list-style: none;
    -webkit-tap-highlight-color: transparent;
}

button {
    all: unset;
    cursor: pointer;
}

a {
    text-decoration: none;
}

.nav-container {
    margin-inline: 1.5rem;
}

/* ========== NAVIGATION MENU ========== */
/*========== Header ==========*/
.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: var(--electric-blue-color);
    box-shadow: 0 2px 16px hsla(220, 32%, 8%, .3);
    z-index: var(--z-fixed);
}


/*========== Nav ==========*/
.nav {
    height: var(--header-height-default);
}

.main {
    margin-top: var(--header-height-default);
}

.nav__logo,
.nav__burger,
.nav__close {
    color: var(--white-color);
}

.nav__data {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.nav__logo {
    /* display: inline-flex; */
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-weight: var(--font-semi-bold);
}

.nav__logo-img {
    font-weight: initial;
    width: 3rem;
    height: 3rem;
}

.nav__logo-text {
    font-size: 1.25rem;
    color: var(--black-color);
    max-width: 25rem;
}

@media screen and (max-width: 1080px) {
    .nav__logo-text {
        font-size: 1rem;
    }
}

@media screen and (max-width: 950px) {
    .nav__logo-text {
        display: none;
    }
}

.nav__toggle {
    position: relative;
    width: 32px;
    height: 32px;
}

.nav__burger,
.nav__close {
    position: absolute;
    width: max-content;
    height: max-content;
    inset: 0;
    margin: auto;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    transition: opacity .1s, transform .4s;
}

.nav__close {
    opacity: 0;
}

/* Navigation for mobile */
@media screen and (max-width: 800px) {
    .nav__menu {
        pointer-events: none;
        position: absolute;
        left: 0;
        top: calc(var(--header-height-mobile) - 1rem);
        top: 10rem;
        width: 100%;
        height: calc(100vh - var(--header-height-mobile));
        overflow: auto;
        opacity: 0;
        transition: top .4s, opacity .3s;
    }

    .nav__menu.show-menu .dropdown__item,
    .nav__menu.show-menu .dropdown__menu,
    .nav__menu.show-menu .nav__link {
        pointer-events: initial;
    }

    .nav__menu {
        scrollbar-width: none;
    }

    .nav__menu::-webkit-scrollbar {
        width: 0;
    }

    .nav__list {
        background-color: var(--electric-blue-color);
        padding-top: 1rem;
        height: max-content;
    }


}

.nav__link {
    color: var(--white-color);
    background-color: var(--electric-blue-color);
    font-weight: var(--font-semi-bold);
    padding: 1.25rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background-color .3s;
}

.nav__link:hover {
    background-color: var(--electric-blue-color-light);
}

/* Show menu */
.show-menu {
    opacity: 1;
    top: var(--header-height-default);
}

.show-icon .nav__burger {
    opacity: 0;
    transform: rotate(90deg);
}

.show-icon .nav__close {
    opacity: 1;
    transform: rotate(90deg);
}

/*========== Dropdown ==========*/

.dropdown__item,
.dropdown__menu,
.nav__link {
    pointer-events: none;
}

.dropdown__item {
    flex: 1 1;
    flex-basis: 0;
    cursor: pointer;
}

.dropdown__arrow {
    width: 1.25rem;
    height: 1.25rem;
    transition: transform .4s;
}

.dropdown__link {
    padding: 1.25rem 1.25rem 1.25rem 2.5rem;
    color: var(--white-color);
    background-color: var(--electric-blue-color-light);
    display: flex;
    align-items: center;
    /* gap: .5rem */
    font-weight: var(--font-semi-bold);
    transition: background-color .3s;
}

.dropdown__link:hover {
    background-color: var(--electric-blue-color);
}

.dropdown__menu {
    max-height: 0;
    overflow: hidden;
    transition: max-height .3s;
}

/* Show dropdown menu & submenu */
.dropdown__menu.active {
    max-height: 100vh;
}

/* Rotate dropdown icon */
.dropdown__arrow.active {
    transform: rotate(180deg);
}

/*========== Breakpoints ==========*/
/* For small devices */
@media screen and (max-width: 450px) {
    .container {
        margin-inline: 1rem;
    }

    .nav__logo-text {
        font-size: 1rem;
        max-width: 15rem;
    }

    .nav__link {
        padding-inline: 1rem;
    }
}

/* For large devices */
@media screen and (min-width: 800px) {
    .nav {
        display: flex;
        justify-content: space-between;
        gap: 5rem;
    }

    .nav__menu {
        flex: 1 1;
    }

    .nav__toggle {
        display: none;
    }

    .nav__list {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        column-gap: 3rem;
    }

    .dropdown__item {
        pointer-events: initial;
        position: relative;
        min-width: 8rem;
        max-width: 14rem;
        display: flex;
        justify-content: center;
        flex: 1 1;
    }

    .nav__link {
        pointer-events: none;
        height: 100%;
        padding: 0;
        justify-content: initial;
        column-gap: .25rem;
    }

    .nav__link.single {
        pointer-events: initial;
    }

    .nav__link:hover {
        background-color: transparent;
    }

    .dropdown__menu {
        max-height: initial;
        width: 100%;
        overflow: initial;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: calc(var(--header-height-desktop) - 1rem);
        opacity: 0;
        transition: opacity .3s, top .3s;
    }

    /* Show dropdown menu */
    .dropdown__item:hover .dropdown__menu {
        max-height: 100vh;
        pointer-events: inherit;
        opacity: 1;
        top: calc(var(--header-height-desktop));
        transition: top .3s;
    }

    .dropdown__item:hover .dropdown__arrow {
        transform: rotate(180deg);
    }

    .dropdown__link {
        padding-inline: 1rem 3.5rem;
    }

    .dropdown__link {
        padding-inline: 1rem;
    }


}

/*========== ERROR MODAL ==========*/
.error {
    color: red;
}

.nav-error {
    color: red;
    height: var(--header-height);
    max-width: 150px;
    font-size: 1rem;
    font-weight: var(--font-semi-bold);
    display: flex;
    align-items: center;
}

/* ========== HOMEPAGE ========== */
.home {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}

/* ========== Alert ========== */
.alert-message {
    padding: 1rem;
    background-color: var(--black-color);
    color: var(--electric-yellow)
}

.alert-message>p {
    margin: 0 auto;
    max-width: 80%;
}

/* ========== UTILITIES ========== */
.grid-container {
    display: grid;
    gap: 1rem;
    padding: var(--content-padding-big);
    ;
}

.m-top {
    margin-top: calc(var(--header-height-default) + 2rem);
}

.rich-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3rem;
}

.container {
    padding: var(--content-padding-big);
}

.center {
    display: flex;
    justify-content: center;
    align-items: center;
}


.clickable {
    cursor: pointer;
    pointer-events: initial;
}

.vu-img-container {
    height: 50px;
    width: 50px;
}

.vu-img-container>img {
    width: 100%;
    height: 100%;

}

.footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    height: 100px;
    border-top: 1px solid var(--black-color);
    padding: 2rem 0;
    text-align: center;
    margin-top: 2rem;
}

/* ========== TEMPORARY ========== */

.temp-container {
    padding: var(--content-padding-big);
}

/* ik its bad but who really cares */
* li {
    margin-left: 30px;
}

.nav__list li {
    margin-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,+BAA+B;;IAE/B,qDAAqD;;IAErD,+BAA+B;IAC/B,6CAA6C;IAC7C,iCAAiC;IACjC,uCAAuC;IACvC,yCAAyC;IACzC,mBAAmB;IACnB,iCAAiC;IACjC,8BAA8B;IAC9B,oCAAoC;IACpC,2BAA2B;IAC3B,0BAA0B;;IAE1B,4CAA4C;IAC5C,gCAAgC;IAChC,qCAAqC;IACrC,2BAA2B;IAC3B,+BAA+B;IAC/B,wCAAwC;;IAExC,oCAAoC;IACpC,mBAAmB;IACnB,qBAAqB;;IAErB,gCAAgC;IAChC,eAAe;IACf,cAAc;;AAElB;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,oDAAoD;IACxD;;AAEJ;;AAEA,6BAA6B;AAC7B;IACI,sBAAsB;IACtB,UAAU;IACV,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,6BAA6B;IAC7B,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,kCAAkC;IAClC,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,0CAA0C;AAC1C,+BAA+B;AAC/B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,4CAA4C;IAC5C,6CAA6C;IAC7C,uBAAuB;AAC3B;;;AAGA,4BAA4B;AAC5B;IACI,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,UAAU;AACd;;AAEA,0BAA0B;AAC1B;IACI;QACI,oBAAoB;QACpB,kBAAkB;QAClB,OAAO;QACP,6CAA6C;QAC7C,UAAU;QACV,WAAW;QACX,iDAAiD;QACjD,cAAc;QACd,UAAU;QACV,gCAAgC;IACpC;;IAEA;;;QAGI,uBAAuB;IAC3B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,4CAA4C;QAC5C,iBAAiB;QACjB,mBAAmB;IACvB;;;AAGJ;;AAEA;IACI,yBAAyB;IACzB,4CAA4C;IAC5C,kCAAkC;IAClC,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kDAAkD;AACtD;;AAEA,cAAc;AACd;IACI,UAAU;IACV,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA,iCAAiC;;AAEjC;;;IAGI,oBAAoB;AACxB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;IACzB,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,iCAAiC;AACjC;IACI,iBAAiB;AACrB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;AAC7B;;AAEA,oCAAoC;AACpC,sBAAsB;AACtB;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;QACb,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,aAAa;QACb,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb,uBAAuB;QACvB,SAAO;IACX;;IAEA;QACI,oBAAoB;QACpB,YAAY;QACZ,UAAU;QACV,wBAAwB;QACxB,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,iBAAiB;QACjB,kBAAkB;QAClB,SAAS;QACT,2BAA2B;QAC3B,8CAA8C;QAC9C,UAAU;QACV,gCAAgC;IACpC;;IAEA,uBAAuB;IACvB;QACI,iBAAiB;QACjB,uBAAuB;QACvB,UAAU;QACV,uCAAuC;QACvC,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,oBAAoB;IACxB;;;AAGJ;;AAEA,oCAAoC;AACpC;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,kCAAkC;IAClC,aAAa;IACb,mBAAmB;AACvB;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,oCAAoC;IACpC;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,SAAS;IACT,mCAAmC;;AAEvC;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,wCAAwC;IACxC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,oCAAoC;;AAEpC;IACI,mCAAmC;AACvC;;AAEA,oCAAoC;AACpC;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap\");\n\n:root {\n    --header-height-mobile: 5.5rem;\n    --mobile-width: 800px;\n    --header-height-desktop: 6.5rem;\n\n    --header-height-default: var(--header-height-desktop);\n\n    /*========== Colors ==========*/\n    /*Color mode HSL(hue, saturation, lightness)*/\n    --black-color: hsl(220, 24%, 12%);\n    --black-color-light: hsl(220, 24%, 15%);\n    --black-color-lighten: hsl(220, 20%, 18%);\n    --white-color: #fff;\n    --body-color: hsl(220, 100%, 97%);\n    --electric-blue-color: #009fe3;\n    --electric-blue-color-light: #00acf6;\n    --neon-green-color: #66e700;\n    --electric-yellow: #eeff07;\n\n    /*========== Font and typography ==========*/\n    /*.5rem = 8px | 1rem = 16px ...*/\n    --body-font: \"Montserrat\", sans-serif;\n    --normal-font-size: .938rem;\n    --content-padding-small: 0 2rem;\n    --content-padding-big: 0 min(10%, 10rem);\n\n    /*========== Font weight ==========*/\n    --font-regular: 400;\n    --font-semi-bold: 600;\n\n    /*========== z index ==========*/\n    --z-tooltip: 10;\n    --z-fixed: 100;\n\n}\n\n@media screen and (min-width: 950px) {\n    :root {\n        --normal-font-size: 1rem;\n    }\n}\n\n@media screen and (max-width: 800px) {\n    :root {\n        --header-height-default: var(--header-height-mobile);\n    }\n\n}\n\n/*========== Base ==========*/\n* {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n}\n\nhtml,\nbody {\n    height: 100vh;\n    font-family: var(--body-font);\n    font-size: var(--normal-font-size);\n    background-color: var(--body-color);\n    /* scroll-behavior: smooth; */\n}\n\nol {\n    counter-reset: item;\n}\n\nol>li {\n    list-style-type: none;\n    position: relative;\n}\n\nol>li {\n    display: block;\n}\n\nol>li:before {\n    position: absolute;\n    content: counter(item) \".\";\n    font-weight: var(--font-semi-bold);\n    counter-increment: item;\n    color: var(--black-color);\n    display: inline-block;\n    left: -18px\n}\n\nul {\n    list-style: none;\n    -webkit-tap-highlight-color: transparent;\n}\n\nbutton {\n    all: unset;\n    cursor: pointer;\n}\n\na {\n    text-decoration: none;\n}\n\n.nav-container {\n    margin-inline: 1.5rem;\n}\n\n/* ========== NAVIGATION MENU ========== */\n/*========== Header ==========*/\n.header {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: var(--electric-blue-color);\n    box-shadow: 0 2px 16px hsla(220, 32%, 8%, .3);\n    z-index: var(--z-fixed);\n}\n\n\n/*========== Nav ==========*/\n.nav {\n    height: var(--header-height-default);\n}\n\n.main {\n    margin-top: var(--header-height-default);\n}\n\n.nav__logo,\n.nav__burger,\n.nav__close {\n    color: var(--white-color);\n}\n\n.nav__data {\n    height: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.nav__logo {\n    /* display: inline-flex; */\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    font-weight: var(--font-semi-bold);\n}\n\n.nav__logo-img {\n    font-weight: initial;\n    width: 3rem;\n    height: 3rem;\n}\n\n.nav__logo-text {\n    font-size: 1.25rem;\n    color: var(--black-color);\n    max-width: 25rem;\n}\n\n@media screen and (max-width: 1080px) {\n    .nav__logo-text {\n        font-size: 1rem;\n    }\n}\n\n@media screen and (max-width: 950px) {\n    .nav__logo-text {\n        display: none;\n    }\n}\n\n.nav__toggle {\n    position: relative;\n    width: 32px;\n    height: 32px;\n}\n\n.nav__burger,\n.nav__close {\n    position: absolute;\n    width: max-content;\n    height: max-content;\n    inset: 0;\n    margin: auto;\n    width: 2rem;\n    height: 2rem;\n    cursor: pointer;\n    transition: opacity .1s, transform .4s;\n}\n\n.nav__close {\n    opacity: 0;\n}\n\n/* Navigation for mobile */\n@media screen and (max-width: 800px) {\n    .nav__menu {\n        pointer-events: none;\n        position: absolute;\n        left: 0;\n        top: calc(var(--header-height-mobile) - 1rem);\n        top: 10rem;\n        width: 100%;\n        height: calc(100vh - var(--header-height-mobile));\n        overflow: auto;\n        opacity: 0;\n        transition: top .4s, opacity .3s;\n    }\n\n    .nav__menu.show-menu .dropdown__item,\n    .nav__menu.show-menu .dropdown__menu,\n    .nav__menu.show-menu .nav__link {\n        pointer-events: initial;\n    }\n\n    .nav__menu {\n        scrollbar-width: none;\n    }\n\n    .nav__menu::-webkit-scrollbar {\n        width: 0;\n    }\n\n    .nav__list {\n        background-color: var(--electric-blue-color);\n        padding-top: 1rem;\n        height: max-content;\n    }\n\n\n}\n\n.nav__link {\n    color: var(--white-color);\n    background-color: var(--electric-blue-color);\n    font-weight: var(--font-semi-bold);\n    padding: 1.25rem 1.5rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: background-color .3s;\n}\n\n.nav__link:hover {\n    background-color: var(--electric-blue-color-light);\n}\n\n/* Show menu */\n.show-menu {\n    opacity: 1;\n    top: var(--header-height-default);\n}\n\n.show-icon .nav__burger {\n    opacity: 0;\n    transform: rotate(90deg);\n}\n\n.show-icon .nav__close {\n    opacity: 1;\n    transform: rotate(90deg);\n}\n\n/*========== Dropdown ==========*/\n\n.dropdown__item,\n.dropdown__menu,\n.nav__link {\n    pointer-events: none;\n}\n\n.dropdown__item {\n    flex: 1;\n    flex-basis: 0;\n    cursor: pointer;\n}\n\n.dropdown__arrow {\n    width: 1.25rem;\n    height: 1.25rem;\n    transition: transform .4s;\n}\n\n.dropdown__link {\n    padding: 1.25rem 1.25rem 1.25rem 2.5rem;\n    color: var(--white-color);\n    background-color: var(--electric-blue-color-light);\n    display: flex;\n    align-items: center;\n    /* gap: .5rem */\n    font-weight: var(--font-semi-bold);\n    transition: background-color .3s;\n}\n\n.dropdown__link:hover {\n    background-color: var(--electric-blue-color);\n}\n\n.dropdown__menu {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height .3s;\n}\n\n/* Show dropdown menu & submenu */\n.dropdown__menu.active {\n    max-height: 100vh;\n}\n\n/* Rotate dropdown icon */\n.dropdown__arrow.active {\n    transform: rotate(180deg);\n}\n\n/*========== Breakpoints ==========*/\n/* For small devices */\n@media screen and (max-width: 450px) {\n    .container {\n        margin-inline: 1rem;\n    }\n\n    .nav__logo-text {\n        font-size: 1rem;\n        max-width: 15rem;\n    }\n\n    .nav__link {\n        padding-inline: 1rem;\n    }\n}\n\n/* For large devices */\n@media screen and (min-width: 800px) {\n    .nav {\n        display: flex;\n        justify-content: space-between;\n        gap: 5rem;\n    }\n\n    .nav__menu {\n        flex: 1;\n    }\n\n    .nav__toggle {\n        display: none;\n    }\n\n    .nav__list {\n        height: 100%;\n        width: 100%;\n        display: flex;\n        justify-content: flex-end;\n        column-gap: 3rem;\n    }\n\n    .dropdown__item {\n        pointer-events: initial;\n        position: relative;\n        min-width: 8rem;\n        max-width: 14rem;\n        display: flex;\n        justify-content: center;\n        flex: 1;\n    }\n\n    .nav__link {\n        pointer-events: none;\n        height: 100%;\n        padding: 0;\n        justify-content: initial;\n        column-gap: .25rem;\n    }\n\n    .nav__link.single {\n        pointer-events: initial;\n    }\n\n    .nav__link:hover {\n        background-color: transparent;\n    }\n\n    .dropdown__menu {\n        max-height: initial;\n        width: 100%;\n        overflow: initial;\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n        top: calc(var(--header-height-desktop) - 1rem);\n        opacity: 0;\n        transition: opacity .3s, top .3s;\n    }\n\n    /* Show dropdown menu */\n    .dropdown__item:hover .dropdown__menu {\n        max-height: 100vh;\n        pointer-events: inherit;\n        opacity: 1;\n        top: calc(var(--header-height-desktop));\n        transition: top .3s;\n    }\n\n    .dropdown__item:hover .dropdown__arrow {\n        transform: rotate(180deg);\n    }\n\n    .dropdown__link {\n        padding-inline: 1rem 3.5rem;\n    }\n\n    .dropdown__link {\n        padding-inline: 1rem;\n    }\n\n\n}\n\n/*========== ERROR MODAL ==========*/\n.error {\n    color: red;\n}\n\n.nav-error {\n    color: red;\n    height: var(--header-height);\n    max-width: 150px;\n    font-size: 1rem;\n    font-weight: var(--font-semi-bold);\n    display: flex;\n    align-items: center;\n}\n\n/* ========== HOMEPAGE ========== */\n.home {\n    display: flex;\n    flex-direction: column;\n    gap: 3rem;\n}\n\n/* ========== Alert ========== */\n.alert-message {\n    padding: 1rem;\n    background-color: var(--black-color);\n    color: var(--electric-yellow)\n}\n\n.alert-message>p {\n    margin: 0 auto;\n    max-width: 80%;\n}\n\n/* ========== UTILITIES ========== */\n.grid-container {\n    display: grid;\n    gap: 1rem;\n    padding: var(--content-padding-big);\n    ;\n}\n\n.m-top {\n    margin-top: calc(var(--header-height-default) + 2rem);\n}\n\n.rich-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 3rem;\n}\n\n.container {\n    padding: var(--content-padding-big);\n}\n\n.center {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n.clickable {\n    cursor: pointer;\n    pointer-events: initial;\n}\n\n.vu-img-container {\n    height: 50px;\n    width: 50px;\n}\n\n.vu-img-container>img {\n    width: 100%;\n    height: 100%;\n\n}\n\n.footer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    height: 100px;\n    border-top: 1px solid var(--black-color);\n    padding: 2rem 0;\n    text-align: center;\n    margin-top: 2rem;\n}\n\n/* ========== TEMPORARY ========== */\n\n.temp-container {\n    padding: var(--content-padding-big);\n}\n\n/* ik its bad but who really cares */\n* li {\n    margin-left: 30px;\n}\n\n.nav__list li {\n    margin-left: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
